import { css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const loaderContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export const container = css`
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing3});
  padding: 0 var(${SpacingToken.Spacing5});
  width: 100%;
  max-width: 400px;
  margin-top: 56px;

  ${MEDIA_MIN_SM} {
    margin-top: 118px;
  }
`;

export const header = css`
  margin-bottom: var(${SpacingToken.Spacing7});
`;

export const formField = css`
  width: 100%;
`;

export const passwordField = css`
  width: 100%;
  margin-bottom: var(${SpacingToken.Spacing3});
`;

export const disabledInput = `
  > input {
    cursor: not-allowed;
    color: var(${DesignToken.ContentBasicDisabled});
  } 
`;

export const button = css`
  width: 100%;
`;

export const successContainer = css`
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing3});
  padding: 0 var(${SpacingToken.Spacing5});
  margin-top: 168px;
`;
